import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import dimensions from './dimensions'
import financialAccounts from './financial-accounts'
import appContext from './app-context'
import firstAllocation from './first-allocation'
import secondAllocation from './second-allocation'
import allocationActivities from './allocation-activities'
import thirdAllocation from './third-allocation'
import fourthAllocation from './fourth-allocation'
import fifthAllocation from './fifth-allocation'
import sixthAllocation from './sixth-allocation'
import model from './model'
import scenario from './scenario'
import report from './report'
import calculatedDrivers from './calculatedDrivers'
import VuexPersist from 'vuex-persist';
import user from './user';
import transactionalData from './transactional-data'
import calculatedDriversBeta from './calculatedDriversBeta'
import costPools from './cost-pools'
import companies from './companies'
import notifications from './notifications'
import pdfReport from './pdf-report'
import workspace from './workspace'
Vue.use(Vuex)


const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  reducer: state => ({
    appContext: state.appContext,
    companies: state.companies,
    workspace: state.workspace
  }),
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    dimensions,
    financialAccounts,
    appContext,
    firstAllocation,
    secondAllocation,
    allocationActivities,
    thirdAllocation,
    fourthAllocation,
    fifthAllocation,
    sixthAllocation,
    model,
    scenario,
    report,
    calculatedDrivers,
    user,
    transactionalData,
    calculatedDriversBeta,
    costPools,
    companies,
    notifications,
    pdfReport,
    workspace
  },
  strict: process.env.DEV,
  plugins: [vuexLocalStorage.plugin]
})
